module.exports = __webpack_public_path__ + "img/thumbnail_FennecFox_f_normal.6b9a2fc5.png";